var exports = {
  "n": "xcc377c0b--cc3bea--link",
};

module.exports = exports;
